/** Scroll offsets and timings for the scenario page's auto-scroll (builder, chart, field-import landing). */
export const SCENARIO_SCROLL = {
  BUILDER_OFFSET: 100,
  // Clears the page's sticky settings bar (~66px), which sits above the chart.
  CHART_OFFSET: 100,
  INCOMPLETE_SCENARIO_OFFSET: 80,
  // How close (in px) an element's top must be to its target offset to count as "aligned".
  ALIGNMENT_TOLERANCE_PX: 48,
  // Share of the chart (or of the viewport, whichever is smaller) that must already be visible to count as on screen.
  CHART_IN_VIEW_RATIO: 0.5,
  // During the field-import landing, the transition modal's layout settles asynchronously, so the
  // builder scroll is retried until it lands (or the attempt cap is hit), and re-anchored if it drifts.
  BUILDER_SCROLL_RETRY_LIMIT: 3,
  BUILDER_REANCHOR_THROTTLE_MS: 80,
  // How far the page must move before a drift re-anchor fires during the field-import landing.
  SCROLL_DRIFT_THRESHOLD_PX: 30,
} as const;
